"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aboutToDistrictInfo = void 0;
var marked_1 = require("marked");
var xmldom_1 = require("xmldom");
exports.aboutToDistrictInfo = function (props) {
    if (!props.about)
        return props;
    if (!props.about.startsWith('#'))
        return props;
    var aboutSeo = marked_1.marked.parse(props.about);
    var elements = Array.from(new xmldom_1.DOMParser().parseFromString(aboutSeo, "text/html").childNodes).filter(function (it) { return it.tagName; });
    var districtInfo = [];
    for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
        var element = elements_1[_i];
        if (element.tagName == 'h1' || element.tagName == 'h2' || element.tagName == 'h3') {
            // Convert h1 tags to h2 to avoid SEO issues
            if (element.tagName == 'h1') {
                // Get the serialized h1 string and replace h1 tags with h2 tags
                var h1String = (new xmldom_1.XMLSerializer()).serializeToString(element);
                var h2String = h1String.replace(/<h1/g, '<h2').replace(/<\/h1>/g, '</h2>');
                districtInfo.push({ key: h2String, value: [] });
            }
            else {
                districtInfo.push({ key: (new xmldom_1.XMLSerializer()).serializeToString(element), value: [] });
            }
        }
        else if (element.tagName) {
            if (districtInfo[districtInfo.length - 1]) {
                districtInfo[districtInfo.length - 1].value.push((new xmldom_1.XMLSerializer()).serializeToString(element));
            }
        }
    }
    return __assign(__assign({}, props), { districtInfo: districtInfo });
};
